import { useCallback } from 'react';
import { copyText } from '@/lib/clipboard';
import { useSavedFlash } from './useSavedFlash';

const COPIED_FLASH_MS = 1200;

/**
 * Copies text to the clipboard and exposes a transient `copied` flag that
 * stays true for ~1.2 s — enough to flash a checkmark in place of the copy
 * icon. Callers don't need to manage timers themselves.
 */
export function useCopyToClipboard(): { copied: boolean; copy: (text: string) => Promise<void> } {
  const [copied, trigger] = useSavedFlash(COPIED_FLASH_MS);

  const copy = useCallback(
    async (text: string) => {
      await copyText(text);
      trigger();
    },
    [trigger],
  );

  return { copied, copy };
}
